export default () =>
  import(
    /* webpackChunkName: 'coffee/app/download/kiosk' */ './Kiosk'
  );
